import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ErrorToast, SuccessToast } from "../components/toastMessage";
import { _axios } from "../utils/axios";

export type TRegistrationField = {
  registration_field_id: number;
  uid?: string;
  field_type?: string;
  label_name?: string;
  active?: boolean;
  mandatory?: boolean;
  placeholder_name?: string;
  updated_date?: string;
  options?: {
    id: number;
    name: string;
    active?: boolean;
  }[];
};

export function usePatchRegistrationField() {
  return useMutation<
    { success: boolean },
    AxiosError | Error,
    {
      registration_field_id: number;
      label_name?: string;
      placeholder_name?: string;
      active?: boolean;
      mandatory?: boolean;
      options?: number[];
    }
  >({
    mutationFn: (rest) =>
      _axios
        .patch<{ success: boolean }>(`/registration-fields`, rest)
        .then((res) => res.data),
    onError: () => {
      ErrorToast("Something went wrong while updating field!");
    },
    onSuccess: () => {
      SuccessToast("Field updated successfully!");
    },
  });
}
